import React, { useState } from 'react';
import ChevronUp from '../../../../images/thin_chevron_up.svg';
import ChevronDown from '../../../../images/thin_chevron_down.svg';
import MobilePrimaryLink from './mobile-primary-link';
import MobileSecondaryLink from './mobile-secondary-link';
import useDelayUnmount from '../../../../hooks/useDelayUnmount';
import { Item } from './mobile-nav'

interface MobileDropdownToggleProps {
  label: string;
  items: Item[];
  onClickHideMenu?: () => void;
  ctaLink?: string;
}

const MobileDropdownToggle = ({ label, items, onClickHideMenu, ctaLink }: MobileDropdownToggleProps) => {
  const [isMounted, setIsMounted] = useState<boolean>(false);
  const showDropdown = useDelayUnmount({ isMounted, delayTime: 250 });
  const toggleDropdown = (): void => setIsMounted(prevOpen => !prevOpen);

  const mainItems: Item[] = items.filter(item => item.childItems.nodes.length === 0);
  const secondaryItemsParent: Item | undefined = items.find(item => item.childItems && item.childItems.nodes.length > 0);
  const secondaryItems: Item[] | undefined = secondaryItemsParent?.childItems?.nodes;

  return (
    <div className={`mobile-dropdown-trigger ${isMounted ? 'open' : ''}`}>
      <div className='toggle' onClick={toggleDropdown}>
        <span>{label}</span>
        <img className='chevron' src={isMounted ? ChevronUp : ChevronDown} alt={isMounted ? "arrow up" : "arrow down"} />
      </div>
      { showDropdown ?
      <div className={`mobile-dropdown-wrapper ${isMounted ? 'mount' : 'unmount'}`}>
        <div className='main-items-wrapper'>
        {mainItems.map((item, index) => {
          return <MobilePrimaryLink key={index} label={item.label} link={item.uri} image={item.menuIcons?.icon?.mediaItemUrl} altText={item.menuIcons?.icon?.altText} onClickHideMenu={onClickHideMenu} ctaLink={ctaLink}/>
        }) }
        </div>
        { (showDropdown && secondaryItems?.length && secondaryItems?.length > 0) ?
        <div className='secondary-items-wrapper'>
          <hr className='mobile-secondary-items-separator' />
          <p className='secondary-items-label'>{secondaryItemsParent?.label}</p>
          {secondaryItems?.map((item, index) => {
            return <MobileSecondaryLink key={index} item={item} />
          })}
        </div> : null
      }
      </div> : null}
    </div>
  )
}

export default MobileDropdownToggle;
